import { TextCodes } from '@api/types/translation/TextCodes';
import { BackButton, Title, useBuyersCertificateCreateContext } from '@components';
import { useAppSelector, useAuth } from '@hooks';
import PrintIcon from '@mui/icons-material/Print';
import { Box, Button, Stack } from '@mui/material';
import { getSpecialPage } from '@store/app/app.slice';
import { t } from '@translations';

type BuyersCertificateDetailsHeaderProps = {
  title?: string;
  canEditData?: boolean;
};

export const BuyersCertificateDetailsHeader: React.FC<BuyersCertificateDetailsHeaderProps> = ({
  title,
  canEditData,
}: BuyersCertificateDetailsHeaderProps) => {
  const { isBeremaUser } = useAuth();
  const dealerBuyersCertificateListPage = useAppSelector(
    getSpecialPage('dealerBuyersCertificateListPage')
  );
  const beremaBuyersCertificateListPage = useAppSelector(
    getSpecialPage('beremaBuyersCertificateListPage')
  );
  const buyersCertificateListPage = isBeremaUser
    ? beremaBuyersCertificateListPage
    : dealerBuyersCertificateListPage;

  const { isEditEnabled, toggleEdit } = useBuyersCertificateCreateContext();
  const handlePrint = () => {
    window.print();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: title ? 'space-between' : 'flex-end',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <div>
        <BackButton href={buyersCertificateListPage} />
        {title && (
          <Title variant='h2' sx={{ mb: 4 }}>
            {title}
          </Title>
        )}
      </div>
      <Stack direction='row' spacing={2}>
        <Button variant='primary' onClick={handlePrint} startIcon={<PrintIcon />}>
          {t(TextCodes.Base.Print)}
        </Button>
        {canEditData && !isEditEnabled && (
          <Button variant='secondary' onClick={toggleEdit}>
            {t(TextCodes.Base.Edit)}
          </Button>
        )}
        {canEditData && isEditEnabled && (
          <Button variant='secondary' onClick={toggleEdit}>
            {t(TextCodes.Base.Cancel)}
          </Button>
        )}
      </Stack>
    </Box>
  );
};
